import { ReactElement } from 'react';

function InputOtp(props: any): ReactElement<HTMLInputElement> {
  return (
    <input
      className="p-2 border rounded-lg text-sm text-center font-body focus:outline-none focus:border-primary"
      type="text"
      maxLength={1}
      {...props}
    />
  );
}

export default InputOtp;
